// app/javascript/controllers/category_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categoryLabel", "inputObservationCategory", "categoryItem"]

  connect() {
    this.categories = this.categoryLabelTarget.dataset.categories.split(",")
    this.forceCategoryValue()
    this.checkCategories()
  }

  checkCategories() {
    this.categoryItemTargets.forEach((item) => {
      if (this.categories.includes(item.textContent.trim())) {
        item.classList.add("category-checked")
      }
    });
  }

  toggleCategory(event) {
    const categoryLabel = event.currentTarget
    const category = categoryLabel.textContent.trim()

    if (categoryLabel.classList.contains("category-checked")) {
      categoryLabel.classList.remove("category-checked")
      const index = this.categories.indexOf(category)
      if (index > -1) {
        this.categories.splice(index, 1);
      }
    } else {
      categoryLabel.classList.add("category-checked")
      this.categories.push(category)
    }
    this.forceCategoryValue()
  }

  forceCategoryValue() {
    const string = this.categories.toString()
    this.inputObservationCategoryTarget.value = string
  }
}
